import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportMemberTransactionPage } from './report-member-transaction.page';

const routes: Routes = [
  {
    path: '',
    component: ReportMemberTransactionPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportMemberTransactionPageRoutingModule {}
